import React from 'react';

export type SidebarContextProps = {
  state: 'collapsed' | 'expanded';
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  mobileIsOpen: boolean;
  setMobileIsOpen: (isOpen: boolean) => void;
  toggle: () => void;
  isMobile: boolean;
};

export const SidebarContext = React.createContext<SidebarContextProps | null>(null);
